import { render } from "./RenewPackage.vue?vue&type=template&id=1950deca&scoped=true"
import script from "./RenewPackage.vue?vue&type=script&lang=js"
export * from "./RenewPackage.vue?vue&type=script&lang=js"

import "./RenewPackage.vue?vue&type=style&index=0&id=1950deca&scoped=true&lang=css"

import exportComponent from "/home/user/devops/sourcecode/Sopecam/sopecam-cameroontribune-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1950deca"]])

export default __exports__